import React, { Component } from 'react';
import EffectParameterSlider from './EffectParameterSlider.js';
import ParameterKnob from 'components/knobs/ParameterKnob.js';

class CompressorEffect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            effect: props.effect,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        this.state.effect = nextProps.effect;
        return true;
    }

    isEnabled() {
        return this.props.automation !== undefined ? true :
            this.state.effect.isEnabled();
    }

    render() {
        let compressor = this.state.effect.compressorNode;
        let gainNode = this.state.effect.effectNode;
        let className = this.props.automation !== undefined ?
            'enabled tall-effect effect effect-automation' :
            this.state.effect.isEnabled() ? 'tall-effect effect enabled' :
            'effect disabled';
        return (
            <div>
              {!this.isEnabled() ? '' :
                <div>
                  <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                        name='Gain'
                        selectedParameter={this.props.selectedParameter}
                        sequencerEngine={this.props.sequencerEngine}
                        lfoEnabled={true}
                        parameter={this.state.effect.gainParameter}
                        isParameter={true}
                        onParameterChanged={this.props.onParameterChanged}
                        step={0.1}
                        max={6}
                        min={0.1}
                        />
                  <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                        name='Threshold'
                        sequencerEngine={this.props.sequencerEngine}
                        lfoEnabled={true}
                    scrollContainer={this.props.scrollContainer}
                        selectedParameter={this.props.selectedParameter}
                        parameter={this.state.effect.thresholdParameter}
                        isParameter={true}
                        onParameterChanged={this.props.onParameterChanged}
                        step={0.1}
                        max={0}
                        min={-80}
                        />
                  <div className="knobs">
                    <ParameterKnob
                        effectNumber={this.props.effectNumber}
                      scrollContainer={this.props.scrollContainer}
                      automation={this.props.automation}
                      name='Ratio'
                        sequencerEngine={this.props.sequencerEngine}
                        lfoEnabled={true}
                        selectedParameter={this.props.selectedParameter}
                        parameter={this.state.effect.ratioParameter}
                        onParameterChanged={this.props.onParameterChanged}
                        isParameter={true}
                        step={0.1}
                        max={20}
                        min={1}
                        />
                      <ParameterKnob
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                      scrollContainer={this.props.scrollContainer}
                        name='Knee'
                        sequencerEngine={this.props.sequencerEngine}
                        lfoEnabled={true}
                        selectedParameter={this.props.selectedParameter}
                        parameter={this.state.effect.kneeParameter}
                        onParameterChanged={this.props.onParameterChanged}
                        isParameter={true}
                        step={0.1}
                        max={40}
                        min={0}
                        />
                   
                      <ParameterKnob
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                            name='Attack'
                      scrollContainer={this.props.scrollContainer}
                        sequencerEngine={this.props.sequencerEngine}
                        lfoEnabled={true}
                            selectedParameter={this.props.selectedParameter}
                            parameter={this.state.effect.attackParameter}
                            isParameter={true}
                            onParameterChanged={this.props.onParameterChanged}
                            step={0.001}
                            max={1}
                            min={0}
                            />
                          <ParameterKnob
                            effectNumber={this.props.effectNumber}
                            automation={this.props.automation}
                            name='Release'
                            selectedParameter={this.props.selectedParameter}
                            sequencerEngine={this.props.sequencerEngine}
                            lfoEnabled={true}
                            parameter={this.state.effect.releaseParameter}
                            isParameter={true}
                            onParameterChanged={this.props.onParameterChanged}
                            step={0.001}
                            scrollContainer={this.props.scrollContainer}
                            max={1}
                            min={0.15}
                          />
                  </div>
                  </div>} 
            </div>
        );
    }
}

export default CompressorEffect;
